import type { TranslationSchema } from '@/locales/schema'

export const es: TranslationSchema = {
  common: {
    appName: 'Longbourn',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Añadir',
    search: 'Buscar',
    showingResults: 'Mostrando {{start}}-{{end}} de {{total}} resultados',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    filter: 'Filtrar',
    sort: 'Ordenar',
    yes: 'Sí',
    no: 'No',
    optional: 'Opcional',
    confirm: 'Confirmar',
    by: 'por',
    setDate: 'establecer fecha',
    clearAll: 'Limpiar Todo',
    minimum: 'Mínimo',
    maximum: 'Máximo',
    ascending: 'Ascendente',
    descending: 'Descendente',
    dateAdded: 'Fecha Agregada',
    exactlyStars: '{{stars}} estrellas',
    rangeStars: '{{min}} - {{max}} estrellas',
    noResultsMessage: 'No se encontraron resultados',
    selectAll: 'Seleccionar Todo',
    deselectAll: 'Deseleccionar Todo',
    apply: 'Aplicar',
    saving: 'Guardando...',
  },
  errors: {
    general: 'Ocurrió un error',
    userNotAuthenticated: 'Usuario no autenticado',
    somethingWentWrong:
      'Algo salió mal. Nuestro equipo ha sido notificado y estamos trabajando para solucionar el problema.',
    errorOccurred: 'Ocurrió un error al procesar su solicitud',
    invalidISBN: 'Formato de ISBN inválido',
    isbnNotFound: 'No se encontraron datos para este ISBN',
    networkError: 'Error de red. Por favor, verifica tu conexión e intenta nuevamente.',
    tryAgain: 'Intentar de nuevo',
    goBack: 'Volver al inicio',
    technicalDetails: 'Detalles técnicos',
    devOnly: 'solo dev',
  },
  auth: {
    signIn: 'Iniciar Sesión',
    signOut: 'Cerrar Sesión',
    signUp: 'Crear Cuenta',
    signInWithGoogle: 'Iniciar sesión con Google',
    signInWithEmail: 'Iniciar sesión con Email',
    createAccount: 'Crear Cuenta',
    resetPassword: 'Restablecer Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    backToSignIn: 'Volver al Inicio de Sesión',
    signingIn: 'Iniciando sesión...',
    signingOut: 'Cerrando sesión...',
    welcomeBack: 'Bienvenido de vuelta',
    yourPersonalLibrary: 'Tu compañero de biblioteca personal',
    bySigningIn: 'Al iniciar sesión, aceptas organizar tu viaje de lectura',
    madeWithLove: 'Hecho con ❤️ para amantes de los libros',
    signInError: 'Error al iniciar sesión con Google. Por favor, inténtalo de nuevo.',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    fullName: 'Nombre Completo',
    email: 'Email',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    fullNamePlaceholder: 'Ingresa tu nombre completo',
    emailPlaceholder: 'Ingresa tu email',
    passwordPlaceholder: 'Ingresa tu contraseña',
    confirmPasswordPlaceholder: 'Confirma tu contraseña',
    noAccount: '¿No tienes una cuenta?',
    haveAccount: '¿Ya tienes una cuenta?',
    emailRequired: 'El email es requerido',
    emailInvalid: 'Por favor, ingresa un email válido',
    passwordRequired: 'La contraseña es requerida',
    passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
    nameRequired: 'El nombre completo es requerido',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    invalidCredentials: 'Email o contraseña inválidos',
    emailNotConfirmed: 'Por favor, verifica tu email y confirma tu cuenta',
    userAlreadyExists: 'Una cuenta con este email ya existe',
    generalError: 'Ocurrió un error durante la autenticación',
    setNewPassword: 'Establecer Nueva Contraseña',
    enterNewPassword: 'Ingresa tu nueva contraseña a continuación',
    newPassword: 'Nueva Contraseña',
    confirmNewPassword: 'Confirmar Nueva Contraseña',
    updatePassword: 'Actualizar Contraseña',
    passwordUpdated: '¡Contraseña Actualizada!',
    passwordUpdateSuccess: 'Tu contraseña ha sido actualizada exitosamente.',
    redirectingToLogin: 'Redirigiendo a la página de inicio de sesión...',
    checkYourEmail: 'Revisa tu Email',
    resetEmailSent: 'Enviamos un enlace de recuperación a {{email}}',
    resetEmailInstructions: 'Haz clic en el enlace del email para restablecer tu contraseña.',
  },
  navigation: {
    dashboard: 'Panel',
    myBooks: 'Mis Libros',
    digitalShelf: 'Estante Digital',
    wishlist: 'Lista de Deseos',
    bookRoulette: 'Ruleta de Libros',
    billing: 'Facturación',
    settings: 'Configuración',
    notes: 'Notas',
    yearInReview: 'Resumen del año',
    clubs: 'Clubes',
  },
  billing: {
    title: 'Facturación',
    subtitle: 'Gestiona tu suscripción y método de pago',
    loading: 'Cargando información de facturación...',
    status: {
      title: 'Estado de Suscripción',
      currentStatus: 'Estado Actual:',
      exemptAccess: 'Tienes acceso exento al sistema',
      exemptAs: 'como {{reason}}',
      expiresOn: 'Expira el: {{date}}',
      trialExpiresOn: 'Prueba expira el:',
    },
    subscription: {
      title: 'Detalles de Suscripción',
      plan: 'Plan:',
      nextBilling: 'Próxima facturación:',
      status: 'Estado:',
      active: 'Activo',
      monthly: 'Mensual',
      annual: 'Anual',
      cancelScheduled: 'Cancelación programada',
      cancelDate: 'Tu suscripción será cancelada el {{date}}',
    },
    manage: {
      title: 'Gestionar Suscripción',
      description: 'Actualiza método de pago, descarga facturas o cancela tu suscripción',
      button: 'Gestionar Suscripción',
      redirecting: 'Redirigiendo...',
    },
    upgrade: {
      title: 'Elige tu Plan',
      description: 'Desbloquea todas las funcionalidades de Longbourn',
      monthly: {
        title: 'Mensual',
        price: '{{price}}',
        period: '/mes',
        cta: 'Elegir Mensual',
      },
      annual: {
        title: 'Anual',
        price: '{{price}}',
        period: '/año',
        savings: 'Ahorra {{amount}} ({{percent}}% de descuento)',
        perMonth: '{{price}}/mes',
        cta: 'Elegir Anual',
        badge: 'Más Popular',
      },
      processing: 'Procesando...',
      benefits:
        '✅ Todas las funciones • 📊 Análisis avanzados • 🎯 Soporte prioritario • 🚫 Sin límites',
      cancelAnytime: 'Cancela en cualquier momento',
    },
    badge: {
      loading: 'Cargando...',
      exempt: 'Exento - {{reason}}',
      exemptSpecial: 'Exento - Especial',
      annual: 'Plan Anual',
      monthly: 'Plan Mensual',
      trial: 'Trial - {{days}} día{{s}} restante{{s}}',
      trialExpired: 'Trial Expirado',
      noAccess: 'Sin Acceso',
      // New cancellation statuses
      pastDue: 'Pago Vencido',
      canceled: 'Suscripción Cancelada',
      canceledWithAccess: '{{days}} días restantes',
      cancelingAtPeriodEnd: 'Cancelando al Final del Período',
      trialing: 'Período de Prueba',
      inactive: 'Inactivo',
      reasons: {
        beta_tester: 'Beta Tester',
        partner: 'Socio',
        lifetime: 'Vitalicio',
        promotional: 'Promocional',
        staff: 'Personal',
        investor: 'Inversor',
      },
    },
  },
  dashboard: {
    welcomeBack: '¡Bienvenido de vuelta, {{name}}!',
    readingJourneyOverview: 'Aquí tienes un resumen de tu viaje de lectura',
    stats: {
      totalBooks: 'Total de Libros',
      booksRead: 'Libros Leídos',
      readThisYear: 'Leídos Este Año',
      currentlyReading: 'Leyendo Actualmente',
      wishlist: 'Lista de Deseos',
      startAddingBooks: 'Empieza a añadir libros a tu biblioteca',
      percentOfCollection: '{{percent}}% de tu colección',
      booksInProgress: 'Libros en progreso',
      booksToReadLater: 'Libros para leer después',
      ofTotal: 'del total',
      favoriteGenre: 'Tu género favorito es',
      noFavoriteGenre: 'Añade géneros a tus libros para descubrir tu favorito',
      booksWithGenre: 'libros',
      ownedPlusBorrowed_one: 'Solo los tuyos · +{{count}} prestado fuera del total',
      ownedPlusBorrowed_other: 'Solo los tuyos · +{{count}} prestados fuera del total',
      readIncludesBorrowed_one: 'Incluye {{count}} libro prestado',
      readIncludesBorrowed_other: 'Incluye {{count}} libros prestados',
    },
    analytics: {
      title: 'Analytics',
    },
    charts: {
      yearlyProgress: 'Progreso Anual',
      typeDistribution: 'Distribución por Tipo',
      libraryStatus: 'Estado de la Biblioteca',
      libraryStatusDescription: 'Visión general de libros por estado y tipo',
      topGenres: 'Top Géneros',
      topGenresDescription: 'Géneros más presentes en tu biblioteca',
      ratingDistribution: 'Distribución de Calificaciones',
      averageRating: 'Promedio',
      ratedBooks: 'libros calificados',
      noRatedBooks: 'Ningún libro calificado aún',
      comingSoon: 'Próximamente...',
      booksReadIn: 'libros leídos en',
      booksThisMonth: 'libros este mes',
      totalSoFar: 'total hasta ahora',
      books: 'libros',
      booksTotal: 'libros en total',
      totalBooks: 'Total',
      booksRead: 'Leídos',
      percentageOfLibrary: 'De la biblioteca',
      percentage: 'Porcentaje',
      star: 'estrella',
      stars: 'estrellas',
      ofTotal: 'del total',
      noData: 'Datos insuficientes para mostrar el gráfico',
      noDataTitle: 'No hay datos disponibles',
      addBooksToSeeDistribution: 'Añade libros a tu biblioteca para ver la distribución',
      addBooksToSeeStatus: 'Añade libros a tu biblioteca para ver el estado',
      noGenresTitle: 'No se encontraron géneros',
      addGenresToBooks: 'Añade géneros a tus libros para ver estadísticas',
      noRatingsTitle: 'No hay calificaciones aún',
      rateYourBooks: 'Califica tus libros leídos para ver estadísticas',
    },
  },
  books: {
    myBooks: 'Mis Libros',
    yourCollection: 'Tu colección de libros aparecerá aquí',
    booksCount: '{{count}} libros en tu biblioteca',
    wishlistCount: '{{count}} libros en tu lista de deseos',
    noBooksYet: 'Aún no hay libros',
    addBook: 'Añadir Libro',
    editBook: 'Editar Libro',
    deleteBook: 'Eliminar Libro',
    confirmDelete: {
      title: 'Eliminar Libro',
      message:
        '¿Estás seguro de que quieres eliminar "{{title}}"? Esta acción no se puede deshacer.',
    },
    noBooks: 'Aún no hay libros en tu biblioteca',
    addFirstBook: 'Añade tu primer libro',
    startAddingBooks: 'Comienza añadiendo algunos libros a tu colección',
    tryAdjustingFilters: 'Intenta ajustar tu búsqueda o filtros',
    bookAdded: 'Libro añadido con éxito',
    bookUpdated: 'Libro actualizado con éxito',
    bookDeleted: 'Libro eliminado con éxito',
    fields: {
      title: 'Título',
      author: 'Autor',
      isbn: 'ISBN',
      coverUrl: 'URL de Imagen de Portada',
      publishedYear: 'Año de Publicación',
      pages: 'Páginas',
      genre: 'Género',
      status: 'Estado',
      type: 'Tipo',
      rating: 'Calificación',
      notes: 'Notas',
      genres: 'Géneros',
      selectGenres: 'Seleccionar géneros...',
      selectGenresHelp: 'Selecciona géneros que mejor describan el libro',
      noGenresAvailable: 'No hay géneros disponibles',
      searchGenres: 'Buscar géneros...',
      noGenresFound: 'No se encontraron géneros',
      startDate: 'Iniciado',
      endDate: 'Finalizado',
      borrowed: 'Libro prestado (no es mío)',
      borrowedFrom: 'Prestado por',
      borrowedFromPlaceholder: '¿De quién? (opcional)',
      borrowedHelp:
        'Los libros prestados cuentan como lectura, pero no en el total de tu biblioteca.',
    },
    isbn: {
      searching: 'Buscando...',
      search: 'Buscar',
      bookFound:
        'Libro encontrado! Datos completados automáticamente. Puedes editarlos a continuación.',
      enterIsbnHelp:
        'Ingresa el ISBN para completar automáticamente título, autor y otra información',
      checkingDuplicate: 'Verificando duplicados...',
      duplicateFound: 'Este ISBN ya está registrado para el libro "{{title}}"',
    },
    scanner: {
      title: 'Escanear Código de Barras',
      instructions: 'Apunta la cámara al código de barras ISBN en la parte posterior del libro',
      scanning: 'Buscando código de barras...',
      startingCamera: 'Iniciando cámara...',
      noCameraSupport: 'Cámara no compatible en este dispositivo',
      permissionDenied:
        'Permiso de cámara denegado. Permite el acceso a la cámara para escanear códigos.',
      noCameraFound: 'No se encontró cámara en este dispositivo',
      unknownError: 'Ocurrió un error al acceder a la cámara',
      tryAgain: 'Intentar de Nuevo',
      scanBarcode: 'Escanear Código',
      positionBarcode: 'Posiciona el código de barras dentro del rectángulo',
      codeFound: '¡Código encontrado!',
      processing: 'Procesando...',
    },
    status: {
      toRead: 'Por Leer',
      reading: 'Leyendo',
      read: 'Leído',
      wishlist: 'Lista de Deseos',
      unread: 'No Leído',
    },
    type: {
      physical: 'Libro Físico',
      digital: 'Libro Digital',
    },
    actions: {
      title: 'Acciones',
      rate: 'Calificar libro leído',
      writeReview: 'Escribir reseña',
      yourNotes: 'Tus notas',
      clickToWriteReview: 'Haz clic para escribir tu reseña',
      markAsReadToRate: 'Marca como leído para cambiar',
      removeRating: 'Eliminar calificación',
      noRating: 'Sin calificación',
      rateExperience: 'Califica tu experiencia de lectura',
      oneStarRating: '⭐ 1 estrella',
      twoStarRating: '⭐⭐ 2 estrellas',
      threeStarRating: '⭐⭐⭐ 3 estrellas',
      fourStarRating: '⭐⭐⭐⭐ 4 estrellas',
      fiveStarRating: '⭐⭐⭐⭐⭐ 5 estrellas',
      addNotesPlaceholder: 'Añade tus notas sobre el libro...',
      whenStartedReading: 'Cuándo empezaste a leer este libro',
      whenFinishedReading: 'Cuándo terminaste de leer este libro',
      startReadingToday: 'Empezar a leer hoy',
      markAsReadToday: 'Marcar como leído hoy',
      reread: 'Releer libro',
      moveToWishlist: 'Mover a lista de deseos',
      startReadingNow: 'Empezar a leer ahora',
      acquiredBook: 'Adquirí el libro',
      moveToLibrary: 'Mover a biblioteca',
      confirmDeleteTitle: 'Eliminar libro',
      confirmDeleteMessage:
        '¿Estás seguro de que quieres eliminar "{{title}}"? Esta acción no se puede deshacer.',
      coverUrlHelp:
        'URL de imagen de portada (completado automáticamente con ISBN o puedes ingresar manualmente)',
    },
    filters: {
      readInYear: 'Leídos en {{year}}',
      clearReadYear: 'Quitar filtro de año',
    },
  },
  roulette: {
    title: 'Ruleta de Libros',
    description: 'Deja que el azar decida tu próxima lectura',
    spin: 'Girar',
    createRoulette: 'Crear Ruleta',
    selectBooks: 'Seleccionar Libros para Ruleta',
    selectBooksDescription: 'Elige al menos 1 libro para crear tu ruleta de lectura',
    minimumBooks: 'Selecciona al menos 1 libro',
    booksSelected: 'seleccionados',
    startRoulette: 'Iniciar Ruleta',
    noBooksFound: 'No se encontraron libros',
    adjustFiltersToFindBooks: 'Intenta ajustar tus filtros para encontrar libros',
    spinning: 'Girando',
    spinningDescription: 'La ruleta está eligiendo tu próxima aventura...',
    readyToSpin: '¡Listo para girar!',
    booksInRoulette: '{{count}} libros en la ruleta',
    winner: '¡Ganador!',
    yourNextRead: 'Tu próxima lectura es...',
    markAsNextRead: 'Marcar como Próxima Lectura',
    startReadingNow: 'Empezar a Leer Ahora',
    spinAgain: 'Girar de Nuevo',
    viewHistory: 'Ver Historial',
    funFact: '¡La ruleta ha hablado! Es hora de comenzar tu viaje de lectura.',
    history: 'Historial de Ruleta',
    historyDescription: 'Rastrea tus giros de ruleta y descubrimientos de lectura',
    backToRoulette: 'Volver a Ruleta',
    clearHistory: 'Limpiar Historial',
    noHistory: 'No hay historial de ruleta aún',
    noHistoryDescription: '¡Comienza a girar para construir tu historial de ruleta!',
    startFirstRoulette: 'Iniciar Primera Ruleta',
    totalSpins: 'Giros Totales',
    thisWeek: 'Esta Semana',
    avgDuration: 'Duración Promedio',
    uniqueBooks: 'Libros Únicos',
    allTime: 'Todo el Tiempo',
    last24Hours: 'Últimas 24 Horas',
    sortByDate: 'Ordenar por Fecha',
    sortByBook: 'Ordenar por Libro',
    showingResults: 'Mostrando {{count}} de {{total}} resultados',
    spinDuration: 'Duración del Giro',
    roulettePick: 'Elección de Ruleta',
    noResultsForFilter: 'No hay resultados que coincidan con el filtro actual',
    // New persistent roulette translations
    myRoulettes: 'Mis Ruletas',
    manageRouletteCollections: 'Gestiona tus colecciones de ruleta guardadas',
    createNew: 'Crear Nueva',
    noRoulettesYet: 'Aún no hay ruletas',
    createFirstRouletteDescription:
      'Crea tu primera ruleta temática para organizar tus selecciones de libros por género, estado de ánimo o cualquier categoría que te guste.',
    createFirstRoulette: 'Crear Tu Primera Ruleta',
    sortByUpdated: 'Actualizadas Recientemente',
    sortByName: 'Nombre',
    sortBySpins: 'Más Giros',
    roulettesCount: 'ruletas',
    books: 'Libros',
    spins: 'Giros',
    currentlyReading: 'Leyendo Actualmente',
    lastSpin: 'Último giro',
    needMinimumBooks: 'Añade al menos 1 libro para girar',
    addMoreBooksToSpin: 'Añade más libros para habilitar el giro',
    // Create roulette specific translations
    createRouletteDescription: 'Crea una colección temática de libros para selección aleatoria',
    rouletteConfiguration: 'Configuración de Ruleta',
    rouletteName: 'Nombre de Ruleta',
    selectBooksMessage: 'Seleccionar Libros ({{count}} seleccionados)',
    minimumBooksWarning: '⚠️ Selecciona al menos 1 libro para crear una ruleta',
    nameRequired: 'Nombre *',
    namePlaceholder: 'ej., Clásicos de Ciencia Ficción',
    descriptionOptional: 'Descripción',
    descriptionPlaceholder: 'Descripción opcional para esta ruleta...',
    colorTheme: 'Tema de Color',
    icon: 'Icono',
    preview: 'Vista Previa',
    readyToCreate: '✓ Listo para crear',
    creating: 'Creando...',
    createRouletteButton: 'Crear Ruleta',
    // History specific translations
    errorLoadingHistory: 'Error cargando historial',
    backToRoulettes: 'Volver a Ruletas',
    last24HoursFilter: 'Últimas 24 Horas',
    noSpinsLast24Hours: 'No hay giros en las últimas 24 horas',
    spinLabel: 'giro',
    // Roulette result translations
    newRouletteButton: 'Nueva Ruleta',
    // Pagination
    previous: 'Anterior',
    next: 'Siguiente',
    pageOf: 'Página {{page}} de {{total}}',
    // Error messages
    errorLoadingBooks: 'Error cargando libros',
    noBooksMessage: 'No se encontraron libros',
    adjustFiltersMessage: 'Intenta ajustar tus filtros',
    // Delete roulette
    editRoulette: 'Editar Ruleta',
    deleteRoulette: 'Eliminar Ruleta',
    deleteRouletteTitle: 'Eliminar Ruleta',
    deleteRouletteMessage:
      '¿Estás seguro de que quieres eliminar la ruleta "{{name}}"? Esta acción no se puede deshacer.',
    // Progress and completion
    availableBooks: 'Disponibles',
    spinsCompleted: 'Completados',
    progress: 'Progreso',
    completed: 'Completada',
    allBooksSpun: 'Todos los libros han sido seleccionados',
    noMoreBooksToSpin: 'No hay más libros disponibles para girar',
    allBooksAlreadySpun: 'Todos los libros ya han sido girados',
    alreadySelected: 'ya seleccionado',
    // Progress page translations
    viewProgress: 'Ver Progreso',
    progressDescription: 'Rastrea el progreso de tu ruleta y gira cuando quieras',
    spinWheel: 'Girar Ruleta',
    spinRoulette: 'Girar Ruleta',
    backToList: 'Volver a Lista',
    suggestBooks: 'Sugerir libros',
    suggestHint: 'Elige libros sin leer de los géneros y autores que mejor calificaste',
    suggestedBooks_one: '{{count}} libro sugerido y seleccionado según tus calificaciones.',
    suggestedBooks_other: '{{count}} libros sugeridos y seleccionados según tus calificaciones.',
    noSuggestions: 'Ningún libro sin leer para sugerir.',
  },
  search: {
    title: 'Buscar Libros',
    description: 'Busca en tu biblioteca',
    placeholder: 'Buscar por título, autor o ISBN...',
    searchByTitleAuthor: 'Buscar por título o autor...',
    noResults: 'No se encontraron resultados',
    results: '{{count}} resultado(s) encontrado(s)',
  },
  statistics: {
    title: 'Estadísticas de Lectura',
    description: 'Tus conocimientos y patrones de lectura',
    booksPerMonth: 'Libros por Mes',
    genreDistribution: 'Distribución por Género',
    readingGoal: 'Meta de Lectura',
    averageRating: 'Calificación Promedio',
    totalPages: 'Total de Páginas Leídas',
  },
  wishlist: {
    title: 'Mi Lista de Deseos',
    description: 'Libros que quieres leer en el futuro',
    addToWishlist: 'Añadir a Lista de Deseos',
    addFirstBook: 'Añade tu primer libro a la lista',
    emptyMessage: 'Tu lista de deseos está vacía',
  },
  digitalShelf: {
    title: 'Estante Digital',
    yourCollection: 'Tu colección de libros digitales aparecerá aquí',
    booksCount: '{{count}} libros digitales en tu biblioteca',
    noBooks: 'Sin libros digitales aún',
    addBook: 'Añadir Libro Digital',
    editBook: 'Editar Libro Digital',
    addFirstBook: 'Añade tu primer libro digital',
    startAddingBooks: 'Comienza añadiendo algunos libros digitales a tu colección',
  },
  settings: {
    description: 'Gestiona tus preferencias de cuenta y configuración de la aplicación',
    quickActions: 'Acciones Rápidas',
    comingSoon: 'Próximamente',
    sectionNotFound: 'Sección de configuración no encontrada',
    sections: {
      preferredGenres: {
        description: 'Gestiona tus géneros favoritos',
      },
      account: {
        title: 'Cuenta',
        description: 'Configuración de perfil y cuenta',
      },
      notifications: {
        title: 'Notificaciones',
        description: 'Gestiona preferencias de notificación',
      },
      appearance: {
        title: 'Apariencia',
        description: 'Temas y preferencias visuales',
      },
    },
    preferredGenres: {
      title: 'Géneros Preferidos',
      description: 'Configura tus géneros favoritos para una experiencia personalizada',
      selectedCount: '{{count}} géneros seleccionados',
      smartSuggestions: 'Sugerencias Inteligentes',
      suggestionsHelp: 'Basado en los libros de tu biblioteca actual',
      searchPlaceholder: 'Buscar géneros...',
      suggestions: 'Sugerencias',
      allGenres: 'Todos los Géneros',
      both: 'Ambos',
      basedOnLibrary: 'Basado en Tu Biblioteca',
      otherGenres: 'Otros Géneros',
      clearAll: 'Limpiar Todo',
      selectedSummary: '{{count}} géneros seleccionados',
      noGenresSelected: 'No hay géneros seleccionados',
      selectAll: 'Seleccionar Todos',
    },
  },
  landing: {
    hero: {
      freeTrial: '🎁 14 días gratis',
      title: 'Tu Biblioteca',
      subtitle: 'Inteligente',
      description:
        'Nunca olvides un libro que hayas leído. Descubre insights fascinantes sobre tus hábitos de lectura. Deja que el destino elija tu próxima aventura literaria.',
      startFreeTrial: 'Comenzar Prueba Gratis',
      seeHowItWorks: 'Ver Cómo Funciona',
      dashboardPreview: 'Vista Previa del Dashboard',
    },
    features: {
      title: 'Todo lo que Necesitas para tu Viaje de Lectura',
      subtitle: 'Funciones poderosas diseñadas para amantes de los libros',
      bookRoulette: {
        title: 'Ruleta de Libros',
        badge: 'EXCLUSIVO',
        description:
          '¿No puedes decidir qué leer? ¡Deja que nuestra exclusiva Ruleta de Libros elija tu próxima aventura aleatoriamente! Crea ruletas temáticas y añade un elemento de sorpresa a tu lectura.',
      },
      smartAnalytics: {
        title: 'Análisis Inteligentes',
        description:
          'Gráficos hermosos e insights sobre tus patrones de lectura, géneros favoritos, progreso a lo largo del tiempo y estadísticas detalladas de tu biblioteca personal.',
      },
      barcodeScanner: {
        title: 'Escáner de Códigos de Barras',
        description:
          'Añade libros instantáneamente escaneando códigos de barras ISBN. Los detalles del libro se llenan automáticamente desde nuestra amplia base de datos.',
      },
      smartOrganization: {
        title: 'Organización Inteligente',
        description:
          'Organiza libros por estado, géneros, calificaciones. Rastrea fechas de lectura, añade notas personales y mantén tu biblioteca siempre organizada.',
      },
      readingProgress: {
        title: 'Progreso de Lectura',
        description:
          'Rastrea lo que estás leyendo, quieres leer y has completado con monitoreo detallado de progreso y metas de lectura personalizables.',
      },
      multiLanguage: {
        title: 'Multi-idioma',
        description:
          'Disponible en Portugués, Inglés y Español. Perfecto para amantes de libros internacionales que leen en diferentes idiomas.',
      },
    },
    howItWorks: {
      title: 'Cómo Funciona Longbourn',
      subtitle: 'Comienza en tres simples pasos',
      step1: {
        title: 'Añade Tus Libros',
        description:
          'Escanea códigos de barras, busca por ISBN, o añade libros manualmente para construir tu biblioteca digital.',
      },
      step2: {
        title: 'Organiza y Analiza',
        description:
          'Rastrea tu progreso de lectura y descubre insights sobre tus hábitos con análisis hermosos y detallados.',
      },
      step3: {
        title: 'Descubre lo Siguiente',
        description:
          'Usa la Ruleta de Libros para dejar que el azar decida tu próxima lectura, o navega tu biblioteca organizada.',
      },
    },
    pricing: {
      badge: '🎁 14 días gratis para probar',
      title: 'Elige Tu Plan',
      subtitle: 'Comienza con 14 días gratis. Cancela en cualquier momento.',
      monthly: {
        title: 'Plan Mensual',
        price: '$9,99',
        period: '/mes',
        description: 'Flexibilidad total con pago mensual',
        cta: 'Comenzar Prueba Gratis',
      },
      annual: {
        title: 'Plan Anual',
        price: '$34,99',
        period: '/año',
        originalPrice: '$119,88',
        savings: 'Ahorra $84,89',
        description: '¡Mejor valor! Solo {{perMonth}} por mes',
        discount: '71% DESC',
        cta: 'Comenzar Prueba Gratis',
        prioritySupport: '💎 Acceso prioritario al soporte',
      },
      features: {
        freeTrial: '✨ 14 días de prueba gratuita',
        unlimitedLibrary: 'Biblioteca ilimitada de libros',
        bookRoulette: 'Ruleta de Libros exclusiva',
        barcodeScanner: 'Escáner de códigos de barras',
        detailedAnalytics: 'Análisis detallados',
        multiLanguage: 'Soporte para 3 idiomas',
      },
    },
    spotlight: {
      badge: '🎲 FUNCIÓN EXCLUSIVA',
      title: 'Deja que el Destino Elija tu Próxima',
      titleHighlight: ' Aventura',
      description:
        'Nuestra Ruleta de Libros es la única función de su tipo. Crea ruletas temáticas, gira la rueda y descubre tu próxima gran lectura. ¡Perfecto para lectores indecisos!',
      features: {
        customRoulettes:
          'Crea ruletas temáticas personalizadas por género, estado de ánimo o categoría',
        trackHistory: 'Rastrea tu historial de ruletas y estadísticas de giros',
        neverWorryAgain: 'Nunca más te preocupes por elegir tu próximo libro',
      },
      interactiveRoulette: 'Ruleta Interactiva',
      demoText: 'Demo disponible después del registro',
    },
    cta: {
      title: '¿Listo para Transformar tu Experiencia de Lectura?',
      description:
        'Únete a miles de amantes de los libros que ya han organizado su viaje de lectura con Longbourn.',
      button: 'Comenzar Prueba Gratis',
      benefits: '🎁 14 días gratis • 🚫 Sin tarjeta de crédito • ⚡ Cancela en cualquier momento',
    },
    footer: {
      madeWith: 'Hecho con ❤️ para amantes de los libros en todas partes',
      privacy: 'Privacidad',
      terms: 'Términos',
    },
  },
  insights: {
    title: 'Insights',
    seeAll: 'Ver todos',
    noBooksYet: 'Agrega libros para ver este insight',
    days_one: '{{count}} día',
    days_other: '{{count}} días',
    bookCount_one: '{{count}} libro',
    bookCount_other: '{{count}} libros',
    missingDates: {
      title_one: '{{count}} libro leído sin fecha de término',
      title_other: '{{count}} libros leídos sin fecha de término',
      description: 'Sin la fecha no aparecen en "Leídos este año" ni en el Progreso anual.',
      fix: 'Completar fechas',
      modalTitle: '¿Cuándo terminaste?',
      modalHint:
        'Sugerimos la fecha de la última modificación de cada libro. Ajústala si es necesario.',
    },
    continueReading: {
      title: 'Sigue leyendo',
      empty: 'Ningún libro en curso. ¿Por qué no empiezas uno?',
      noStartDate: 'Sin fecha de inicio',
      startedToday: 'Empezaste hoy',
      daysReading_one: 'Leyendo hace {{count}} día',
      daysReading_other: 'Leyendo hace {{count}} días',
    },
    goal: {
      title: 'Meta de {{year}}',
      empty: 'Define cuántos libros quieres leer en {{year}}.',
      set: 'Definir meta',
      edit: 'Editar meta',
      remove: 'Eliminar meta',
      howMany: '¿Cuántos libros en {{year}}?',
      reached: '¡Meta cumplida! 🎉',
      onTrack: 'Vas al ritmo correcto.',
      ahead_one: '{{count}} libro por delante del ritmo',
      ahead_other: '{{count}} libros por delante del ritmo',
      behind_one: '{{count}} libro por detrás del ritmo',
      behind_other: '{{count}} libros por detrás del ritmo',
    },
    streak: {
      title: 'Racha de lectura',
      months_one: '{{count}} mes',
      months_other: '{{count}} meses',
      start: 'Termina un libro este mes para empezar tu racha.',
      active: 'Ya terminaste un libro este mes. 🔥',
      keepAlive: 'Termina un libro este mes para mantener la racha.',
      longest_one: 'Récord: {{count}} mes',
      longest_other: 'Récord: {{count}} meses',
    },
    readingTime: {
      title: 'Tiempo de lectura',
      basedOn_one: 'Basado en {{count}} libro con fechas',
      basedOn_other: 'Basado en {{count}} libros con fechas',
      empty: 'Completa las fechas de inicio y término de los libros leídos para ver tu ritmo.',
      perBook: 'por libro',
      fastest: 'Más rápido',
      slowest: 'Más lento',
    },
    topAuthors: {
      title: 'Autores principales',
      description: 'Autores con más libros en tu biblioteca',
      readOfTotal: '{{read}}/{{total}} leídos',
    },
    backlog: {
      title: 'Pendientes por género',
      description: 'Dónde están los libros que tienes y aún no leíste',
      empty: 'Agrega géneros a tus libros para ver este insight.',
      unreadOfOwned: '{{unread}} de {{owned}} sin leer',
    },
    pace: {
      title: 'Compra vs. lectura',
      added: 'Agregados',
      finished: 'Terminados',
      noActivity: 'Sin actividad en los últimos 12 meses',
      buyingMore:
        'Últimos 12 meses: {{added}} agregados, {{finished}} terminados. La pila está creciendo.',
      readingMore: 'Últimos 12 meses: {{added}} agregados, {{finished}} terminados. ¡Vas al día!',
    },
    stalled: {
      title: 'Libros detenidos',
      description: 'En "Leyendo" hace más de {{count}} días',
      pause: 'Pausar',
      pauseHint: 'Devuelve el libro a "Por leer"',
    },
    preferred: {
      title: 'Gustos vs. lecturas',
      description: 'Géneros que dices preferir comparados con lo que lees',
      noPreferences: 'Aún no elegiste géneros preferidos.',
      setPreferences: 'Elegir ahora',
      preferredTag: 'Género preferido',
      readCount_one: '{{count}} leído',
      readCount_other: '{{count}} leídos',
      surprise: 'Lees bastante {{genre}}, pero no está en tus preferidos.',
      neglected: '{{genre}} está en tus preferidos, pero aún no leíste ninguno.',
    },
    yearInReview: {
      cta: 'Resumen del año',
      title: 'Resumen {{year}}',
      subtitle: 'Tu año de lectura en números',
      selectYear: 'Elegir año',
      share: 'Compartir imagen',
      generating: 'Generando...',
      downloaded: '¡Imagen descargada!',
      imageTitle: 'Mi año de lectura',
      imageBooksRead_one: 'libro leído',
      imageBooksRead_other: 'libros leídos',
      empty: 'Ningún libro terminado en {{year}} todavía.',
      booksRead: 'Libros leídos',
      booksAdded: 'Libros agregados',
      averageRating: 'Calificación media',
      physicalDigital: 'Físico / Digital',
      topGenre: 'Género del año',
      topAuthor: 'Autor del año',
      bestRated: 'Mejor calificado',
      fastest: 'Lectura más rápida',
      busiestMonth: 'Mes más productivo',
      averageTime: 'Tiempo medio',
      allBooks: 'Todos los libros del año',
      shareTitle: '📚 Mi resumen de lectura {{year}}',
    },
    notes: {
      title: 'Notas',
      subtitle_one: '{{count}} libro con notas',
      subtitle_other: '{{count}} libros con notas',
      searchPlaceholder: 'Buscar en notas, títulos y autores...',
      empty: 'Aún no escribiste notas. Agrega notas a tus libros y aparecerán aquí.',
    },
  },
  clubs: {
    title: 'Clubes de lectura',
    subtitle: 'Lee junto a tus amigas: desafíos, préstamos y libros viajeros',
    create: 'Crear club',
    edit: 'Editar club',
    memberCount_one: '{{count}} miembro',
    memberCount_other: '{{count}} miembros',
    notFound: 'Club no encontrado o no eres miembro.',
    backToClubs: 'Volver a los clubes',
    leave: 'Salir del club',
    leaveTitle: '¿Salir del club?',
    leaveMessage: 'Saldrás de "{{club}}". Necesitarás una nueva invitación para volver.',
    deleteTitle: '¿Eliminar club?',
    deleteMessage: '"{{club}}" y todos sus desafíos se eliminarán para todos los miembros.',
    empty: {
      title: 'Aún no estás en ningún club',
      description:
        'Crea un club e invita a tus amigas, o abre el enlace de invitación que recibiste.',
    },
    form: {
      name: 'Nombre del club',
      namePlaceholder: 'Ej.: Club de las Chicas',
      description: 'Descripción',
      descriptionPlaceholder: 'Encuentros mensuales, reglas, lo que quieras…',
      create: 'Crear',
    },
    roles: {
      admin: 'Admin',
      member: 'Miembro',
    },
    members: {
      title_one: '{{count}} miembro',
      title_other: '{{count}} miembros',
      you: 'tú',
      makeAdmin: 'Hacer admin',
      makeMember: 'Quitar admin',
      remove: 'Quitar',
      removeTitle: '¿Quitar miembro?',
      removeMessage: '{{name}} saldrá del club.',
    },
    invite: {
      title: 'Invitar',
      description: 'Genera un enlace y envíalo a quien quieras en el club.',
      create: 'Generar enlace',
      share: 'Compartir enlace',
      copied: '¡Enlace copiado!',
      revoke: 'Desactivar enlace',
      expires: 'Válido hasta {{date}}',
      shareText: 'Únete a "{{club}}" en Longbourn',
    },
    join: {
      invitedBy: '{{name}} te invitó a',
      accept: 'Unirme al club',
      open: 'Abrir club',
      invalid: 'Invitación inválida o vencida',
      invalidHint: 'Pide un nuevo enlace a alguien del club.',
    },
  },
  challenges: {
    title: 'Desafíos',
    create: 'Nuevo desafío',
    edit: 'Editar desafío',
    empty: 'Aún no hay desafíos. ¡Crea uno y cada una sugiere categorías!',
    notFound: 'Desafío no encontrado.',
    formerMember: 'Ex miembro',
    categoryCount_one: '{{count}} categoría',
    categoryCount_other: '{{count}} categorías',
    categoryProgress: '{{count}} de {{total}} categorías definidas',
    myProgress: 'Tú: {{done}}/{{total}}',
    deleteTitle: '¿Eliminar desafío?',
    deleteMessage: '"{{name}}", sus categorías, elecciones y comentarios se eliminarán para todas.',
    phase: {
      upcoming: 'Próximamente',
      active: 'En curso',
      finished: 'Terminado',
    },
    legend: {
      done: 'Leído en el período',
      picked: 'Elegido',
    },
    filter: {
      all: 'Todas las categorías',
      todo: 'Sin libro mío',
      picked: 'Elegido, falta leer',
      done: 'Completadas por mí',
    },
    form: {
      defaultName: 'Desafío {{year}}',
      name: 'Nombre',
      startsOn: 'Inicio',
      endsOn: 'Fin',
      datesInvalid: 'El fin debe ser posterior al inicio.',
      periodHint: 'Solo cuentan los libros terminados dentro de este período.',
      target: 'Total de categorías',
      targetHint: 'Ej.: 33 para 3 personas sugiriendo 11 cada una.',
      description: 'Reglas',
      descriptionPlaceholder: 'Acuerdos del grupo, premios, plazos…',
    },
    categories: {
      title: 'Categorías',
      empty: 'Aún no hay categorías. ¡Sugiere la primera arriba!',
      suggest: 'Sugerir categoría',
      titlePlaceholder: 'Ej.: Libro de tapa blanca',
      descriptionPlaceholder: 'Detalle (opcional)',
      quota: 'Sugeriste {{done}} de {{quota}}',
      similar: 'Ya existe una parecida: "{{title}}"',
      suggestedBy: 'Sugerida por {{name}}',
      by: 'por {{name}}',
      everyonesPicks: 'Elecciones ({{count}})',
      noPicks: 'Nadie eligió un libro todavía.',
      deleteTitle: '¿Eliminar categoría?',
      deleteMessage_one: 'La categoría y {{count}} elección se eliminarán.',
      deleteMessage_other: 'La categoría y {{count}} elecciones se eliminarán.',
    },
    entry: {
      mine: 'Mi libro para esta categoría',
      pickBook: 'Elige un libro de tu biblioteca',
      noBooks: 'Ningún libro disponible',
      pick: 'Elegir',
      addNewBook: 'Agregar libro nuevo',
      newBook: 'Libro nuevo (será tu elección)',
      change: 'Cambiar libro',
      remove: 'Quitar',
      markReadToday: 'Marcar como leído hoy',
      outsidePeriodHint: 'Hoy está fuera del período del desafío',
      readOn: 'leído el {{date}}',
      readOutsidePeriod: 'Leído el {{date}}, fuera del período, no cuenta',
      reading: 'Leyendo',
      notRead: 'Aún no leído',
      picked: 'elegido',
      done: 'leído',
      none: 'sin libro',
      bookDeleted: 'Este libro fue eliminado de tu biblioteca.',
    },
    comments: {
      count_one: '{{count}} comentario',
      count_other: '{{count}} comentarios',
      hide: 'Ocultar comentarios',
      empty: 'Aún no hay comentarios.',
      placeholder: 'Escribe un comentario…',
      send: 'Enviar',
      add: 'Comentar',
    },
  },
  loans: {
    lend: 'Prestar',
    lendTitle: 'Prestar "{{title}}"',
    borrower: 'A quién',
    chooseFriend: 'Elige a alguien de tus clubes',
    someoneElse: 'Otra persona (fuera de la app)',
    friendHint:
      'El libro aparece en su biblioteca como prestado y su lectura cuenta en sus estadísticas.',
    borrowerName: 'Nombre',
    borrowerNamePlaceholder: 'Ej.: Tía Lucía',
    lentOn: 'Prestado el',
    lentTo: 'Con {{name}} desde {{date}}',
    borrowedFrom: 'Prestado por {{name}}',
    borrowed: 'Prestado',
    returned: 'devuelto',
    markReturned: 'Marcar como devuelto',
    cardTitle: 'Préstamos',
    withMe_one: 'Contigo ({{count}})',
    withMe_other: 'Contigo ({{count}})',
    lentOut_one: 'Prestaste ({{count}})',
    lentOut_other: 'Prestaste ({{count}})',
    from: 'de {{name}}',
    to: 'con {{name}}',
    since: 'desde {{date}}',
  },
  traveling: {
    title: 'Libros viajeros',
    create: 'Nuevo libro viajero',
    empty: 'Ningún libro viajando. ¡Haz que uno tuyo pase de mano en mano!',
    book: 'Libro',
    chooseBook: 'Elige un libro tuyo',
    noBooks: 'Ningún libro tuyo disponible',
    route: 'Ruta',
    routeHint: 'Toca a las personas en el orden en que pasará el libro. Al final, vuelve a ti.',
    noReaders: 'Invita a alguien al club primero.',
    note: 'Nota para las lectoras',
    notePlaceholder: 'Ej.: cuidado con la tapa, se puede marcar con lápiz…',
    start: 'Enviar a viajar',
    ownedBy: 'Libro de {{name}}',
    traveling: 'Viajando',
    home: 'Volvió a casa',
    backHome: '🏠 Volvió a casa el {{date}}',
    withReaderToday: 'Con {{name}} desde hoy',
    withReader_one: 'Con {{name}} hace {{count}} día',
    withReader_other: 'Con {{name}} hace {{count}} días',
    next: 'siguiente: {{name}}',
    nextHome: 'después vuelve a la dueña',
    pass: 'Pasar',
    passTo: 'Entregar a {{name}}',
    sendHome: 'Devolver a la dueña',
    passNotePlaceholder: 'Deja una nota para las siguientes (opcional)',
    finished_one: '{{count}} viaje terminado',
    finished_other: '{{count}} viajes terminados',
  },
}
